import React from 'react';
import { TouchableOpacity } from 'react-native-web';
import IconText from '../Text/IconText';

const Square = ({
  isSelected, onPress, backgroundColor = null, text,
}) => (
  <TouchableOpacity
    style={{
      height: 50,
      width: 50,
      borderRadius: 6,
      border: isSelected ? 'solid 2px #008cff' : 'solid 0.6px #cbd5e0',
      boxShadow: '0 0 10px 0 rgba(0, 109, 199, 0.12)',
      backgroundColor,
    }}
    onPress={onPress}
  >
    {text && <IconText>{text}</IconText>}
  </TouchableOpacity>
);
export default Square;
